import { Divider } from "@fluentui/react-components";
import { memo, useCallback } from "react";
import { SuggestionTypeSwitch } from "../../components/SuggestionTypeSwitch";
import { useAppData } from "../../hooks";
import { useAppSelector } from "../../store";
import { SuggestionSearchMode } from "../../types/enums";
import { SuggestionMetadataSelector } from "./components/SuggestionMetadataSelector";
import { SuggestionSearchActions } from "./components/SuggestionSearchActions";
import { SuggestionSearchHistory } from "./components/SuggestionSearchHistory";
import { SuggestionSearchInput } from "./components/SuggestionSearchInput";
import { useStyles } from "./styles";

export type SuggestionSearchFormProps = {
  appId: string;
  searchText?: string;
  searchMode?: SuggestionSearchMode;
  selectedMetadataTags?: Array<{ id: number; name: string }>;
  selectedWorkspaceId?: number;
  onSearchSubmit?: Function;
};

export const SuggestionSearchForm = memo(({ appId, ...props }: SuggestionSearchFormProps) => {
  const styles = useStyles();

  const userId = useAppSelector((state) => state.global?.user?.userId as string);
  const [searchType, setSearchType] = useAppData<SuggestionSearchMode>(appId, "searchType");

  const onSearchTypeChange = useCallback(
    (type: SuggestionSearchMode) => {
      setSearchType(type);
    },
    [setSearchType]
  );

  return (
    <div className={styles.formContainer}>
      <Divider style={{ maxHeight: "20px" }}>New Search</Divider>
      <SuggestionSearchInput className={styles.textInputArea} />
      <SuggestionTypeSwitch type={searchType} onChange={onSearchTypeChange} enableTooltip={true} />
      <SuggestionMetadataSelector appId={appId} />
      <SuggestionSearchActions className={styles.formActionContainer} appId={appId} userId={userId} />
      <Divider className={styles.divider}>Recent Search History</Divider>
      <SuggestionSearchHistory appId={appId} userId={userId} />
    </div>
  );
});
